"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTransformerNamesGroupsBuilder = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const ILevelledTopologicalSorter_1 = require("../interfaces/utils/ILevelledTopologicalSorter");
let AbstractTransformerNamesGroupsBuilder = class AbstractTransformerNamesGroupsBuilder {
    constructor(levelledTopologicalSorter) {
        this.levelledTopologicalSorter = levelledTopologicalSorter;
    }
    build(normalizedTransformers) {
        const transformerNames = Object.keys(normalizedTransformers);
        const relationEdges = this.buildTransformersRelationEdges(transformerNames, normalizedTransformers);
        for (const [precedent, consequent] of relationEdges) {
            this.levelledTopologicalSorter.add(precedent, consequent);
        }
        return this.levelledTopologicalSorter.sortByGroups();
    }
    buildTransformersRelationEdges(transformerNames, normalizedTransformers) {
        const relationEdges = [];
        for (const transformerName of transformerNames) {
            const transformer = normalizedTransformers[transformerName];
            const runAfterRelations = transformer.runAfter;
            const areRunAfterRelationsEmpty = !(runAfterRelations === null || runAfterRelations === void 0 ? void 0 : runAfterRelations.length);
            if (areRunAfterRelationsEmpty) {
                relationEdges.push([transformerName, null]);
                continue;
            }
            for (const runAfterRelation of runAfterRelations) {
                const isUnknownRelation = normalizedTransformers[runAfterRelation] === undefined;
                if (isUnknownRelation) {
                    relationEdges.push([transformerName, null]);
                    continue;
                }
                relationEdges.push([runAfterRelation, transformerName]);
            }
        }
        return relationEdges;
    }
};
AbstractTransformerNamesGroupsBuilder = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ILevelledTopologicalSorter)),
    __metadata("design:paramtypes", [typeof (_a = typeof ILevelledTopologicalSorter_1.ILevelledTopologicalSorter !== "undefined" && ILevelledTopologicalSorter_1.ILevelledTopologicalSorter) === "function" ? _a : Object])
], AbstractTransformerNamesGroupsBuilder);
exports.AbstractTransformerNamesGroupsBuilder = AbstractTransformerNamesGroupsBuilder;
